import { theme } from 'Assets/Styles/theme'

export const styles = {
  container: {
    position: 'relative',
  },
  inputContainer: {
    display: 'block',
    position: 'relative',
    height: '40px',
    width: '100%',
  },
  input: {
    position: 'relative',
    height: '100%',
    width: '100%',
    border: 'none',
    background: theme.colors.alabaster,
    borderRadius: '4px',
    padding: '0 60px 0 20px',

    '&::placeholder': {
      color: theme.colors.placeholder,
      fontSize: theme.fontSizes.header.searchPlaceholder,
    },
  },

  searchIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    borderRadius: '0 4px 4px 0',

    '& svg': {
      fill: theme.colors.white,
      height: '100%',
      left: 0,
      right: 0,
    },
  },
  suggestions: {
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
    zIndex: 10,
    maxHeight: '500px',
    overflowY: 'auto',
    '& ul': {
      margin: '4px -1px',
      padding: 0,
      listStyle: 'none',
      background: 'white',
      border: '1px solid #d1d1d1',
      borderRadius: 2,
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
    },
    '& li': {
      borderBottom: '1px solid #ddd',
      padding: '6px 8px',
    },
    '& li:hover': {
      cursor: 'pointer',
      background: '#eee',
    },
  },
}



// WEBPACK FOOTER //
// ./src/Components/LiveMap/SearchInput/styled.js